/**
 * @desc 新增
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(
  body: defs.appCenter.ViewQueryFieldAddRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/viewQuery/add`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
